export const formatTimeAgo = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "adesso";
  if (diff < 3600) return `${Math.floor(diff / 60)} min fa`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} h fa`;
  return `${Math.floor(diff / 86400)} g fa`;
};

export const formatPrice = (v) => {
  if (v === null || v === undefined) return "";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v);
};

export const STATIC_CATEGORIES = [
  { key: "fabbro", label: "Fabbro", icon: "key" },
  { key: "serrandista", label: "Serrandista", icon: "grid" },
  { key: "elettricista", label: "Elettricista", icon: "flash" },
  { key: "idraulico", label: "Idraulico", icon: "droplets" },
  { key: "soccorso_stradale", label: "Soccorso Stradale", icon: "warning" },
  { key: "batteria_avviamento", label: "Batteria / Avviamento", icon: "battery-charging" },
  { key: "tecnico_condizionatori", label: "Tecnico Condizionatori", icon: "snow" },
  { key: "gommista_mobile", label: "Gommista Mobile", icon: "car" },
  { key: "carro_attrezzi", label: "Carro Attrezzi", icon: "car" },
  { key: "meccanico_mobile", label: "Meccanico Mobile", icon: "wrench" },
  { key: "tecnico_elettrodomestici", label: "Elettrodomestici", icon: "zap" },
  { key: "vetraio", label: "Vetraio", icon: "ellipse" },
];
